import React from 'react';
import Page from '../../component/Page/Page'
import CurrentPositionForm from './CurrentPositionForm'

class CurrentPositionFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    return (
        <Page title="Dados do Mapa" noBreadcrumbs>
          <CurrentPositionForm match={match} history={history}/>
        </Page>
    );
  }
}

export default CurrentPositionFormPage;



// WEBPACK FOOTER //
// ./src/map/currentPosition/CurrentPositionFormPage.js